import * as Api from '@ViewModels';

/**
 * Check if a BrandingSettings object has any meaningful data configured.
 * Used to gate branding UI — colors, font, images, or a brand description
 * all count as "configured".
 */
export function hasBrandingSettings(settings: Api.BrandingSettings | null | undefined): boolean {
	if (!settings) return false;
	return !!(
		settings.brandColors?.length ||
		settings.font?.fontName ||
		settings.images?.length ||
		settings.brandDescription
	);
}
